import Vue from 'vue'
import { mapState } from 'vuex'
import { JobApplicationStatuses } from '@/constants/job/jobApplicationStatuses'
import { JobOfferStages } from '@/constants/job/jobOfferStages'
import { STAGE_BLOCKED_BY_FREELANCER, STAGE_IN_PROGRESS } from '@/constants/job/jobStages'
import { jobPartiesMixin } from '../mixins'

const PAST = 1
const ACTIVE = 2
const FUTURE = 3

export default Vue.extend<any, any, any, any>({
  mixins: [jobPartiesMixin],
  data() {
    return {
      PAST,
      ACTIVE,
      FUTURE,
    }
  },
  computed: {
    ...mapState({
      application: (state: any) => state.jobChat.application.value,
    }),
    isCancelled() {
      return this.application.status === JobApplicationStatuses.ARCHIVED && !this.application.offer
    },
    hasReview() {
      if (!this.application?.isCompleted) return false

      return this.isEmployer ? this.application.customerLeftReview : this.application.freelancerLeftReview
    },
    statuses() {
      const statuses = []
      const offer = { title: 'Offer ', stage: PAST }
      if (!this.application?.offer || this.application.offer.stage !== JobOfferStages.ACCEPTED_BY_CUSTOMER) {
        offer.stage = ACTIVE
      }
      statuses.push(offer)

      const confirmation = { title: 'Confirmation & Deposit', stage: FUTURE }
      if (offer.stage === PAST) {
        confirmation.stage = this.application.wasStarted ? PAST : ACTIVE
      }
      statuses.push(confirmation)

      const inProgress = { title: 'In Progress', stage: FUTURE }
      if (confirmation.stage === PAST) {
        inProgress.stage = [STAGE_IN_PROGRESS, STAGE_BLOCKED_BY_FREELANCER].includes(this.application.job?.stage) ? ACTIVE : PAST
      }
      statuses.push(inProgress)

      const review = { title: 'Review', stage: FUTURE }
      if (inProgress.stage === PAST) {
        review.stage = this.hasReview ? PAST : ACTIVE
      }
      statuses.push(review)
      return [offer, confirmation, inProgress, review]
    },
  },
})
